import React from "react";

const ModerateContributionsIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43.256"
      height="46.838"
      viewBox="0 0 44.162 43.126"
    >
      <g id="db83" transform="translate(-157.425 -162.555)">
        <path
          id="Path_1765"
          data-name="Path 1765"
          d="M180.067,175.845a4.974,4.974,0,0,1-4.969-4.968v-7.4a2.759,2.759,0,0,1,.165-.925H160.55a3.128,3.128,0,0,0-3.125,3.124v36.877a3.128,3.128,0,0,0,3.125,3.125h24.713a3.128,3.128,0,0,0,3.124-3.125V175.678a2.733,2.733,0,0,1-.923.166ZM163.355,170.4h9.452a.92.92,0,1,1,0,1.84h-9.452a.92.92,0,0,1,0-1.84Zm17.955,29.122H163.355a.92.92,0,0,1,0-1.84h17.955a.92.92,0,1,1,0,1.84Zm0-7.183H163.355a.92.92,0,1,1,0-1.84h17.955a.92.92,0,1,1,0,1.84Zm0-7.182H163.355a.92.92,0,1,1,0-1.84h17.955a.92.92,0,1,1,0,1.84Zm0-7.182H163.355a.92.92,0,0,1,0-1.84h17.955a.92.92,0,1,1,0,1.84Z"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1766"
          data-name="Path 1766"
          d="M353.714,174.018h7.4a.935.935,0,0,0,.856-.571.925.925,0,0,0-.2-1l-9.605-9.605a.921.921,0,0,0-1.573.653v7.4a3.132,3.132,0,0,0,3.128,3.128Z"
          transform="translate(-173.647 -0.013)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1767"
          data-name="Path 1767"
          d="M491.737,193.84h-4.278a2.257,2.257,0,0,0-2.079,2.438V199.9h8.446v-3.625a2.264,2.264,0,0,0-2.089-2.438Z"
          transform="translate(-294.824 -28.125)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1768"
          data-name="Path 1768"
          d="M485.38,272.07v9.219a61.208,61.208,0,0,0,3.349,20.158.922.922,0,0,0,1.739,0,60.977,60.977,0,0,0,3.358-20.158V272.07Z"
          transform="translate(-294.824 -98.452)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1769"
          data-name="Path 1769"
          d="M571.208,254.049a.92.92,0,0,0-.561-.193h-1.665v1.84h.745v11.942a.92.92,0,0,0,1.84,0V254.776a.907.907,0,0,0-.359-.727Z"
          transform="translate(-369.979 -82.078)"
          fill={fill ? fill : "#ff7eb5"}
        />
      </g>
    </svg>
  );
};

export default ModerateContributionsIcon;
